import * as yup from "yup";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import {
  getIsAllLogicJumpsFilled,
  getIsSomeLogicJumpsFilled,
} from "./utilities";
import { QUESTION_TYPES_WITH_CHOICES } from "./config";

function requireLogicJumpFieldSchemaIfSomeFilled(schema) {
  return yup.lazy((_, { context }) => {
    if (
      getIsSomeLogicJumpsFilled(context?.logicJumps || []) &&
      !getIsAllLogicJumpsFilled(context?.logicJumps || [])
    ) {
      return schema.required();
    }
    return schema.nullable();
  });
}

export const useQuestionSchema = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "questionnaires.questionBuilder",
  });

  return yup.object({
    id: yup.string().required(),

    question: yup.string().trim().required(t("questionRequired")),

    questionType: yup.string().required(t("typeRequired")),

    isRequired: yup.bool().required(),

    description: yup.string().trim().nullable(),

    allowCommentsOnScale: yup.bool().required(),

    logicJumps: yup.array().of(
      yup.object({
        type: yup.string().required(),
        ifSelectedChoiceId: requireLogicJumpFieldSchemaIfSomeFilled(
          yup.string(),
        ),
        thenQuestionId: requireLogicJumpFieldSchemaIfSomeFilled(yup.string()),
        elseQuestionId: requireLogicJumpFieldSchemaIfSomeFilled(yup.string()),
      }),
    ),

    choices: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          value: yup.string().required(),
        }),
      )
      .when("questionType", {
        is: (value) => QUESTION_TYPES_WITH_CHOICES.includes(value),
        then: (schema) => schema.min(1, t("questionChoicesRequired")),
      }),
  });
};
